import React from 'react'
import logo from '../img/logo.png'

const Header = (props) => {
  return (
    <div className="brand">
      <img src={logo} className="img-responsive" alt=""/>
    </div>  
  );
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js